import { OktellService } from '@/core/services/oktell.service'
import {
    CreateCallBackPayload,
    GetBoxTemplatesParams,
    GetBoxTemplatesResponse,
    GetDeliveryTypesResponse,
    GetWarehouseParams,
    GetWarehouseResponse,
    OktellClientDraftPayload,
    OktellClientPayload,
    OktellCreateWaitListParams,
    OktellDeclineCallPayload,
    OktellEstimatePayload,
    OktellEstimateResponse,
    OktellGetActivityTypesResponse,
    OktellGetCargoVolumesResponse,
    OktellGetCitiesParams,
    OktellGetCitiesResponse,
    OktellGetClientResponse,
    OktellGetCommunicationsParams,
    OktellGetCommunicationsResponse,
    OktellGetCompaniesResponse,
    OktellGetDeclineReasonsResponse,
    OktellGetDirectionTypesResponse,
    OktellGetInvoicesParams,
    OktellGetInvoicesResponse,
    OktellGetReasonsResponse,
    OktellGetWaitListParams,
    OktellGetWaitListResponse,
    OktellGetWhatsappHistoryParams,
    OktellGetWhatsappHistoryResponse,
    OktellGetWhatsappTokenResponse,
    OktellIsHaveWhatsappResponse,
    OktellMultiorderPayload,
    OktellRandomCallPayload,
    OtkellGetInvoiceStatusesResponse,
} from '@/core/types/oktell.types'

const oktellService = new OktellService()

class OktellRealisation {
    getClientByPhone(phone: string): Promise<OktellGetClientResponse> {
        return oktellService.getClientByPhone(phone)
    }

    createClient(payload: OktellClientPayload): Promise<void> {
        return oktellService.createClient(payload)
    }

    getInvoices(params: OktellGetInvoicesParams): Promise<OktellGetInvoicesResponse> {
        return oktellService.getInvoices(params)
    }

    getWaitList(params: OktellGetWaitListParams): Promise<OktellGetWaitListResponse> {
        return oktellService.getWaitList(params)
    }

    createWaitList(payload: OktellCreateWaitListParams): Promise<void> {
        return oktellService.createWaitList(payload)
    }

    createWaitListMass(payload: OktellCreateWaitListParams): Promise<void> {
        return oktellService.createWaitListMass(payload)
    }

    getInvoiceStatuses(): Promise<OtkellGetInvoiceStatusesResponse> {
        return oktellService.getInvoiceStatuses()
    }

    getCommunications(
        params: OktellGetCommunicationsParams
    ): Promise<OktellGetCommunicationsResponse> {
        return oktellService.getCommunications(params)
    }

    getCities(params: OktellGetCitiesParams): Promise<OktellGetCitiesResponse> {
        return oktellService.getCities(params)
    }

    getWhatsappToken(): Promise<OktellGetWhatsappTokenResponse> {
        return oktellService.getWhatsappToken()
    }

    isHaveWhatsapp(phone: string): Promise<OktellIsHaveWhatsappResponse> {
        return oktellService.isHaveWhatsapp(phone)
    }

    sendWhatsappMessage(form_data: FormData): Promise<void> {
        return oktellService.sendWhatsappMessage(form_data)
    }

    getWhatsappHistory(
        params: OktellGetWhatsappHistoryParams
    ): Promise<OktellGetWhatsappHistoryResponse> {
        return oktellService.getWhatsappHistory(params)
    }

    getBoxTemplates(params: GetBoxTemplatesParams): Promise<GetBoxTemplatesResponse> {
        return oktellService.getBoxTemplates(params)
    }

    getDeliveryTypes(): Promise<GetDeliveryTypesResponse> {
        return oktellService.getDeliveryTypes()
    }

    getSenderWarehouse(params: GetWarehouseParams): Promise<GetWarehouseResponse> {
        return oktellService.getSenderWarehouse(params)
    }

    getReceiverWarehouse(params: GetWarehouseParams): Promise<GetWarehouseResponse> {
        return oktellService.getReceiverWarehouse(params)
    }

    estimate(payload: OktellEstimatePayload): Promise<OktellEstimateResponse> {
        return oktellService.estimate(payload)
    }

    createMultiorder(payload: OktellMultiorderPayload): Promise<void> {
        return oktellService.createMultiorder(payload)
    }

    clientDraft(payload: OktellClientDraftPayload): Promise<void> {
        return oktellService.clientDraft(payload)
    }

    randomCall(payload: OktellRandomCallPayload): Promise<void> {
        return oktellService.randomCall(payload)
    }

    createCallBack(payload: CreateCallBackPayload): Promise<void> {
        return oktellService.createCallBack(payload)
    }

    getReasons(): Promise<OktellGetReasonsResponse> {
        return oktellService.getReasons()
    }

    dialogCardNext(): Promise<void> {
        return oktellService.dialogCardNext()
    }

    getCompanyName(id: number): Promise<OktellGetCompaniesResponse> {
        return oktellService.getCompanyName(id)
    }

    getActivityTypes(): Promise<OktellGetActivityTypesResponse> {
        return oktellService.getActivityTypes()
    }

    getCargoVolumes(): Promise<OktellGetCargoVolumesResponse> {
        return oktellService.getCargoVolumes()
    }

    getDirectionTypes(): Promise<OktellGetDirectionTypesResponse> {
        return oktellService.getDirectionTypes()
    }

    getDeclineReasons(): Promise<OktellGetDeclineReasonsResponse> {
        return oktellService.getDeclineReasons()
    }

    declineCall(payload: OktellDeclineCallPayload): Promise<void> {
        return oktellService.declineCall(payload)
    }
}

export const oktell = new OktellRealisation()
